app.DictionaryWordList = app.AbstractCollection.extend({
  model: app.DictionaryWord,

  url() {
    return '/api/v2/dictionary-words';
  },
});
